import { render, staticRenderFns } from "./YandexMapsPage.vue?vue&type=template&id=8144e472&"
import script from "./YandexMapsPage.vue?vue&type=script&lang=js&"
export * from "./YandexMapsPage.vue?vue&type=script&lang=js&"
import style0 from "./YandexMapsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "YandexMapsPage.vue"
export default component.exports